const marqueeElement = class extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('[data-marquee-movement]');

    if (this.trigger) {
      this.trigger.addEventListener('click', () => {
        this.classList.toggle('animation-paused');
      });
    }
  }
};

if (typeof window.customElements.get('marquee-element') === 'undefined') {
  window.customElements.define('marquee-element', marqueeElement);
}
